module.exports = __webpack_public_path__ + "img/horizontal-logo-pink-id.32dc1c33.svg";